import type { ReactElement } from 'react';
import { cn } from '@fshr/shared-react';
import Icon from '../../../icon/icon';

type Props = {
	className?: string;
	iconClassName?: string;
};

/** Ported from `LoadingIndicatorDots.tsx`. Figma's loading state centers the Four Seasons tree mark
 * over the (dimmed) widget content - this reuses that mark, spinning, sized for inline use. */
export default function LoadingDots({ className, iconClassName }: Props = {}): ReactElement {
	return (
		<div
			className={cn('flex items-center justify-center p-400', className)}
			data-testid="loading-dots"
			aria-live="polite"
			aria-busy="true"
		>
			<Icon
				icon="tree"
				className={cn(
					'h-600 w-600 animate-spin text-text-heading [animation-duration:2s]',
					iconClassName
				)}
			/>
		</div>
	);
}
